export default __webpack_public_path__ + "static/media/home1.38e3b82d.jpg";